import { ReduxState } from '../../types'
import { getLoanConfiguratorForm, getLoanPreConfiguratorForm } from '../formSelectors'

export const getLoanConfigurator = (state: ReduxState) => {
  const loanConfiguratorForm = getLoanConfiguratorForm(state)

  return {
    loanAmount: loanConfiguratorForm?.loanAmount,
    term: loanConfiguratorForm?.term,
    insuranceRequested: loanConfiguratorForm?.insuranceRequested,
  }
}

export const getLoanPreConfigurator = (state: ReduxState) => {
  const loanPreConfiguratorForm = getLoanPreConfiguratorForm(state)

  return {
    loanAmount: loanPreConfiguratorForm?.loanAmount,
    term: loanPreConfiguratorForm?.term,
    instalmentDay: loanPreConfiguratorForm?.instalmentDay,
  }
}
